import { createSSRApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import AIChatBar from "@/components/AIChatBar.vue";
import { FEATURE_FLAGS, initializeFeatureFlags } from "@/config/features";

import "@/utils/request-interceptor";
import "ant-design-vue/lib/message/style/index.css";
import "virtual:svg-icons-register";
import "virtual:windi.css";
import "vant/es/dialog/style";
import "vant/es/search/style";
import "vant/es/switch/style";
import "vant/es/tabs/style";
import "vant/es/tab/style";
import "vant/es/image-preview/style";

const pinia = createPinia();

const mountAiChatBar = () => {
  // #ifdef H5
  if (!FEATURE_FLAGS.ai) return;
  try {
    const aiRootId = 'ai-chat-root';
    if (!document.getElementById(aiRootId)) {
      const div = document.createElement('div');
      div.id = aiRootId;
      document.body.appendChild(div);
      const aiApp = createSSRApp(AIChatBar);
      aiApp.mount(div);
    }
  } catch (error) {
    console.error("Failed to mount AI Chat Bar", error);
  }
  // #endif
};

export function createApp() {
  const app = createSSRApp(App);
  // app.use(VueViewer)
  app.use(pinia);

  initializeFeatureFlags().then(mountAiChatBar);

  return {
    app,
  };
}
